import React from 'react';
import { list } from '@randajan/jet-core/eachSync';

import "./Pricelist.scss";
import { Block } from '@randajan/jet-react/dom/block';
import { Button } from '@randajan/jet-react/dom/form';
import { Table } from '@randajan/jet-react/dom/table';
import lang from '../../config/lang';
import { usePromise } from '@randajan/jet-react';

import { Info } from '../../elements/Info/Info';
import { Currency } from '../../elements/Currency/Currency';
import { Article } from '../../elements/Article/Article';
import { page } from '../../config/base';
import { bifrost } from '../../config/bifrost';

const charges = [
    {name:"Pracovní dny od 18:00 do 8:00", rate:"20%"},
    {name:"Pracovní dny od 22:00 do 6:00 a mimo Pracovní dny", rate:"50%"},
    {name:"Urgentní servis do 48 hodin", rate:"50%"},
    {name:"Urgentní servis do 24 hodin", rate:"100%"},
    {name:"Státní svátky", rate:"100%"},
];

export const Pricelist = () => {

    const { result:features, status } = usePromise({}, async _=>{
        const features = await bifrost.tx("sunListFeatures");
        const result = {};
        if (Array.isArray(features)) {
            list(features, row=>{
                const list = result[row.type] || ( result[row.type] = [] );
                list.push({
                    ...row,
                    desc:<p className="desc">{row.desc}{row.info ? <Info caption={row.desc} content={row.info}/> : null}</p>,
                    price_czk:<Currency value={row.price_czk} decimal={2}/>
                })
            }, {
                orderBy:[[v=>v.priority, false], [v=>v.price_czk, false], v=>v.desc]
            });
        }
        return result;
    }, []);

    return (
        <section className="Pricelist" data-status={status}>
            <Block level={0} className="block wall" caption={"Ceník IT služeb"}>
                <Block caption={"IT služby na počkání"}>
                    <Table columns={{ desc: lang.desc, price_czk: lang.price, unit: lang.unit }} rows={features["Služba"]} />
                </Block>
                <Block caption={"Doprava"}>
                    <Table columns={{ desc: lang.desc, price_czk: lang.price, unit: lang.unit }} rows={features["Doprava"]} />
                </Block>
                <Block caption={"Příplatky"}>
                    <Table columns={{ name: lang.desc, rate: lang.charge }} rows={charges} />
                    <Article src="web-pricelist-charges"/>
                </Block>
                <Block caption={"Paušální služby"}>
                    <Table columns={{ desc: lang.desc, price_czk: lang.price, unit: lang.unit }} rows={features["Paušál"]} />
                </Block>
                <Article src="web-pricelist-info"/>
                <Button onSubmit={_ => page.set("pathname", "/price/calc")}>
                    {"Vypočítat měsíční paušál"}
                </Button>
            </Block>
        </section>
    );
}

export default Pricelist;
